import PaymentForm from './PaymentForm';
import PyamentForm from './PaymentForm';

export default PaymentForm;
